var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C8.25 3 4.5 3.47368 4.5 6.78947V15.7895C4.5 17.6179 5.97188 19.1053 7.78125 19.1053L6.375 20.5263V21H8.25L10.125 19.1053H13.875L15.75 21H17.625V20.5263L16.2188 19.1053C18.0281 19.1053 19.5 17.6179 19.5 15.7895V6.78947C19.5 3.47368 15.75 3 12 3ZM7.78125 17.2105C7.00312 17.2105 6.375 16.5758 6.375 15.7895C6.375 15.0032 7.00312 14.3684 7.78125 14.3684C8.55937 14.3684 9.1875 15.0032 9.1875 15.7895C9.1875 16.5758 8.55937 17.2105 7.78125 17.2105ZM11.0625 10.5789H6.375V6.78947H11.0625V10.5789ZM16.2188 17.2105C15.4406 17.2105 14.8125 16.5758 14.8125 15.7895C14.8125 15.0032 15.4406 14.3684 16.2188 14.3684C16.9969 14.3684 17.625 15.0032 17.625 15.7895C17.625 16.5758 16.9969 17.2105 16.2188 17.2105ZM17.625 10.5789H12.9375V6.78947H17.625V10.5789Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainWhite);
export default __webpack_public_path__ + "static/media/train-white.158ad36437061707cf6813fd6ec93296.svg";
export { ForwardRef as ReactComponent };